import * as Actions from '../actions';

// Check localStorage for persisted generating reports
function getPersistedGeneratingReports() {
	try {
		const stored = localStorage.getItem('heidi_generating_cost_reports');
		if (stored) {
			const parsed = JSON.parse(stored);
			// Filter out entries older than 30 minutes
			const now = Date.now();
			const valid = parsed.filter(function(r) { return (now - r.startTime) < 30 * 60 * 1000; });
			if (valid.length !== parsed.length) {
				localStorage.setItem('heidi_generating_cost_reports', JSON.stringify(valid));
			}
			return valid;
		}
	} catch (e) {
		// Ignore
	}
	return [];
}

const initialState = {
	list: [],
	report: null,
	loading: false,
	error: null,
	availableCredentials: [],
	credentialsByProvider: {},
	availableProviders: [],
	selectedProvider: null,
	generatingReportId: null,
	generatingReports: getPersistedGeneratingReports(), // Array of {reportId, credentialName, startTime}
	pagination: {
		page: 1,
		limit: 20,
		total: 0,
		pages: 0
	},
	// Cleanup state
	cleanup: {
		isRunning: false,
		isComplete: false,
		progress: {
			completed: 0,
			total: 0,
			current: null
		},
		results: []
	}
};

const costReportsReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_COST_REPORTS_LIST: {
			return {
				...state,
				list: action.payload,
				error: null
			};
		}
		case Actions.SET_COST_REPORT: {
			return {
				...state,
				report: action.payload,
				error: null
			};
		}
		case Actions.SET_COST_REPORTS_LOADING: {
			return {
				...state,
				loading: action.payload
			};
		}
		case Actions.SET_COST_REPORTS_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.SET_AVAILABLE_CREDENTIALS: {
			// Handle both old array format and new object format with groupedByProvider
			var payload = action.payload;
			var credentials = [];
			var byProvider = {};
			var providers = [];
			
			if (Array.isArray(payload)) {
				// Old format: array of credentials
				credentials = payload;
			} else if (payload && payload.credentials) {
				// New format: { credentials, credentialsByProvider, availableProviders }
				credentials = payload.credentials || [];
				byProvider = payload.credentialsByProvider || {};
				providers = payload.availableProviders || [];
			}
			
			return {
				...state,
				availableCredentials: credentials,
				credentialsByProvider: byProvider,
				availableProviders: providers,
				// Auto-select first available provider if none selected
				selectedProvider: state.selectedProvider || (providers.length > 0 ? providers[0] : null)
			};
		}
		case Actions.SET_SELECTED_PROVIDER: {
			return {
				...state,
				selectedProvider: action.payload
			};
		}
		case Actions.SET_GENERATING_REPORT: {
			return {
				...state,
				generatingReportId: action.payload
			};
		}
		case Actions.ADD_GENERATING_REPORT: {
			var newGenerating = state.generatingReports.concat([action.payload]);
			try {
				localStorage.setItem('heidi_generating_cost_reports', JSON.stringify(newGenerating));
			} catch (e) {}
			return {
				...state,
				generatingReports: newGenerating
			};
		}
		case Actions.REMOVE_GENERATING_REPORT: {
			var filtered = state.generatingReports.filter(function(r) { return r.reportId !== action.payload; });
			try {
				localStorage.setItem('heidi_generating_cost_reports', JSON.stringify(filtered));
			} catch (e) {}
			return {
				...state,
				generatingReports: filtered
			};
		}
		case Actions.CLEAR_COST_REPORT: {
			return {
				...state,
				report: null
			};
		}
		case Actions.CLEAR_COST_REPORTS_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.SET_PAGINATION: {
			return {
				...state,
				pagination: action.payload
			};
		}
		// Cleanup cases
		case Actions.CLEANUP_START: {
			return {
				...state,
				cleanup: {
					isRunning: true,
					isComplete: false,
					progress: {
						completed: 0,
						total: action.payload.total,
						current: null
					},
					results: []
				}
			};
		}
		case Actions.CLEANUP_PROGRESS: {
			return {
				...state,
				cleanup: {
					...state.cleanup,
					progress: {
						...state.cleanup.progress,
						completed: action.payload.completed,
						current: action.payload.current
					}
				}
			};
		}
		case Actions.CLEANUP_RESOURCE_RESULT: {
			return {
				...state,
				cleanup: {
					...state.cleanup,
					progress: {
						...state.cleanup.progress,
						completed: state.cleanup.results.length + 1
					},
					results: state.cleanup.results.concat([action.payload])
				}
			};
		}
		case Actions.CLEANUP_COMPLETE: {
			return {
				...state,
				cleanup: {
					...state.cleanup,
					isRunning: false,
					isComplete: true
				}
			};
		}
		case Actions.CLEANUP_RESET: {
			return {
				...state,
				cleanup: {
					isRunning: false,
					isComplete: false,
					progress: {
						completed: 0,
						total: 0,
						current: null
					},
					results: []
				}
			};
		}
		default: {
			return state;
		}
	}
};

export default costReportsReducer;
